import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationClosingReasonEntity } from '../../../domain/entities/investigation-closing-reason.entity';

export interface GetInvestigationClosingReasonsResult {
  reasons: InvestigationClosingReasonEntity[];
}

@Injectable({ providedIn: 'root' })
export class GetInvestigationClosingReasonsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _toast = inject(ToastProvider);

  public execute(): Observable<GetInvestigationClosingReasonsResult> {
    return this._repository.getClosingReasons().pipe(
      map((reasons) => ({ reasons })),
      catchError((error) => {
        this._toast.error('Failed to load closing reasons', 'Please refresh and try again.');
        return throwError(() => error);
      }),
    );
  }
}
